import { render, staticRenderFns } from "./UsageFeesTokuyoCareInsuranceServiceCostsTableRow.vue?vue&type=template&id=c633166e&scoped=true&lang=pug"
import script from "./UsageFeesTokuyoCareInsuranceServiceCostsTableRow.vue?vue&type=script&lang=ts"
export * from "./UsageFeesTokuyoCareInsuranceServiceCostsTableRow.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesTokuyoCareInsuranceServiceCostsTableRow.vue?vue&type=style&index=0&id=c633166e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c633166e",
  null
  
)

export default component.exports